import React, { Component } from "react";
import PrintPreview from "../PrintPreview";
import PdfStore from "../../../stores/PdfStore";
import { Checkbox, Radio } from "react-icheck";
import { DropdownButton, MenuItem } from "react-bootstrap";
import "./Print.css";
// import SignatureModal from 'component/element/SignatureModal'

var NotificationSystem = require("react-notification-system");
const DEFAUT_ROW = 25;
class PrintDearTaxInvoiceDoc extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      loading: false,
      show_receiving_detail: true,
      data: { itemlist: this.newEmptyRow(DEFAUT_ROW) },
      defaultTypePrint: "3",
      dataList: [],
      signature: { p0: null, p1: null, p2: null, p3: null },
      sigKey: null,
      report_title: "กำลังดึงข้อมูล..",
      pay_by: { cash: false, check: false },
      title_doc_options: [],
      title_doc: "",
      title_doc_active: "",
      tivNo: "",
    };

    var cssPagedMedia = (function () {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    })();

    cssPagedMedia.size = function (size) {
      cssPagedMedia("@page {size: " + size + "}");
    };
    cssPagedMedia.size("portrait");
  }

  componentDidMount() {
    this.loadData();
  }

  newEmptyRow(number) {
    let emptyRow = {};
    if (this.props.doc === "invoice_doc")
      emptyRow = {
        amount: "",
        bf_invoice_item_id: "",
        detail: "",
        discount: "",
        invoice_no: "",
        price_per_unit: "",
        quantity: "",
        seq: "",
      };
    else if (this.props.doc === "taxinvoice_doc")
      emptyRow = {
        amount: "",
        bf_taxinvoice_item_id: "",
        detail: "",
        discount: "",
        taxinvoice_no: "",
        price_per_unit: "",
        quantity: "",
        seq: "",
      };

    return new Array(number).fill(null).map((item, index) => {
      return emptyRow;
    });
  }

  loadData() {
    let { data, show_receiving_detail, title_doc_options } = this.state;
    this.setState({ loading: true });
    PdfStore.loadBNPDoc(
      this.props.doc,
      this.props.param,
      this.props.tivNo,
      (result) => {
        data = result.data;
        if (data.itemlist !== undefined && data.itemlist.length > 0) {
          if (data.itemlist.length < DEFAUT_ROW)
            data.itemlist = data.itemlist.concat(
              this.newEmptyRow(DEFAUT_ROW - data.itemlist.length)
            );
        }
        if (data.show_receiving_detail !== undefined) {
          show_receiving_detail = data.show_receiving_detail;
        }
        if (typeof data.title_doc_options !== "undefined")
          title_doc_options = data.title_doc_options;
        this.setState({
          tivNo: this.props.tivNo,
          title_doc: data.title_doc,
          title_doc_active: data.title_doc,
          title_doc_options: title_doc_options,
          loading: true,
          show_receiving_detail: show_receiving_detail,
          data: data,
          dataList: this.getPagination(data.itemlist),
        });
      }
    );
  }

  renderLogoUrl(logoUrl) {
    let imgUrl = "";
    if (process.env.NODE_ENV == "development") {
      imgUrl = "https://demo2.bigfix.co/korat/pdf/" + logoUrl;
    } else {
      imgUrl = "../" + logoUrl;
    }
    if (logoUrl !== undefined) return <img width="140" src={imgUrl} />;
    else return "";
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getSummaryDiscount() {
    let { data } = this.state;
    let sum = 0;
    data.itemlist.forEach(function (item, index) {
      let discount = item.discount;
      if (
        discount === "" ||
        discount === null ||
        discount === undefined ||
        isNaN(discount)
      )
        discount = 0;

      sum += parseFloat(discount);
    });
    return sum;
  }

  getSummaryAmount() {
    let { data } = this.state;
    let sum = 0;
    data.itemlist.forEach(function (item, index) {
      let amount = item.amount;
      if (
        amount === "" ||
        amount === null ||
        amount === undefined ||
        isNaN(amount)
      )
        amount = 0;

      sum += parseFloat(amount);
    });
    sum = sum - this.getSummaryDiscount();
    return sum;
  }

  getVat(total) {
    let { data } = this.state;
    let sum = 0;
    if (data.vat_type === "VAT_EXCLUDE") {
      sum = total * 0.07;
      return sum;
    } else if (data.vat_type === "VAT_INCLUDE") {
      sum = total * 0.07;
      return sum;
    } else {
      return sum;
    }
  }

  getDiscountPercent(discount = 0, amount = 0) {
    let sum = (discount * 100) / amount;
    return sum;
  }

  onPayChange(field, val) {
    let { pay_by } = this.state;
    pay_by[field] = val;
    this.setState({ pay_by: pay_by });
  }

  renderSignature() {
    let { pay_by, data } = this.state;
    return (
      <div style={{ display: "flex", marginTop: "-10px" }}>
        <div style={{ width: "33%", display: "inline-flex" }}>
          <table className="table table-ssr-general-doc line-mid">
            <tbody>
              <tr>
                <td className="text-left bb-h p1">
                  ได้รับสินค้าและบริการตามรายการข้างต้นถูกต้องเรียบร้อยแล้ว
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h p1">
                  <br />
                </td>
              </tr>
              <tr>
                <td
                  className="text-left bt-h bb-h p1"
                  style={{ cursor: "pointer" }}
                >
                  ผู้รับบริการ.................................................................{" "}
                  <br />
                  Receiver's signature
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h p1">
                  วันที่......................../......................../........................{" "}
                  <br />
                  Date
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ width: "0.33%", display: "inline-flex" }}></div>
        <div style={{ width: "33%", display: "inline-flex" }}>
          <table className="table table-ssr-general-doc line-mid">
            <tbody>
              <tr>
                <td colSpan={2} className="text-left bb-h p1">
                  ชำระโดย:{" "}
                  <Checkbox
                    onChange={this.onPayChange.bind(
                      this,
                      "cash",
                      pay_by.cash ? false : true
                    )}
                    checked={pay_by.cash}
                    checkboxClass="icheckbox_minimal"
                    increaseArea="20%"
                    label={" เงินสด"}
                  ></Checkbox>{" "}
                  <Checkbox
                    onChange={this.onPayChange.bind(
                      this,
                      "check",
                      pay_by.check ? false : true
                    )}
                    checked={pay_by.check}
                    checkboxClass="icheckbox_minimal"
                    increaseArea="20%"
                    label={" เช็ค"}
                  ></Checkbox>
                </td>
              </tr>
              <tr>
                <td
                  className="text-left bt-h bb-h br-h p1"
                  style={{ cursor: "pointer" }}
                >
                  ธนาคาร.........................
                </td>
                <td
                  className="text-left bt-h bb-h bl-h p1"
                  style={{ cursor: "pointer" }}
                >
                  สาขา............................
                </td>
              </tr>
              <tr>
                <td
                  className="text-left bt-h bb-h br-h p1"
                  style={{ cursor: "pointer" }}
                >
                  เลขที่.............................
                </td>
                <td
                  className="text-left bt-h bb-h bl-h p1"
                  style={{ cursor: "pointer" }}
                >
                  ลงวันที่.........................
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="text-left bt-h bb-h p1">
                  <br />
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="text-left bt-h bb-h p1">
                  <br />
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  className="text-left bt-h p1"
                  style={{ cursor: "pointer" }}
                >
                  ผู้รับเงิน/Collector.................................................
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ width: "0.33%", display: "inline-flex" }}></div>
        <div style={{ width: "33%", display: "inline-flex" }}>
          <table className="table table-ssr-general-doc line-mid">
            <tbody>
              <tr>
                <td className="text-center bb-h p1">
                  {data.company_name !== undefined ? data.company_name : ""}{" "}
                  <br />
                  {data.company_en !== undefined
                    ? data.company_en.company_name
                    : ""}
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h p1">
                  <br />
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h p1">
                  <br />
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h p1">
                  <br />
                </td>
              </tr>
              <tr>
                <td
                  className="text-center bt-h p1"
                  style={{ cursor: "pointer" }}
                >
                  ................................................................................{" "}
                  <br />
                  ผู้มีอำนาจลงนาม/AUTHORIZED SIGNATURE
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderBody(itemlist, itemIndex) {
    let { data, show_receiving_detail } = this.state;
    let rdClass = show_receiving_detail ? "item-cshow" : "item-hide";
    return (
      <div>
        <div
          style={{
            width: "39.5%",
            display: "inline-block",
            position: "relative",
          }}
        >
          <p style={{ position: "absolute", top: "-20px", fontSize: "16px" }}>
            เลขประจำตัวผู้เสียภาษี{" "}
            {data.company_tax !== undefined ? data.company_tax : ""}
          </p>
          <table
            className="table table-ssr-general-doc line-low tb-info"
            style={{ height: "85px" }}
          >
            <tbody>
              <tr>
                <td colSpan={2} className='text-left bb-h'>ชื่อ {data.customer_name?data.customer_name+" "+(data.customer_branch!==""?"สาขา "+data.customer_branch:""):""}</td>
              </tr> 
              <tr>  
                <td colSpan={2} className='text-left bb-h bt-h'>เลขประจำตัวผู้เสียภาษี {data.customer_tax===null||data.customer_tax===undefined?'':data.customer_tax}</td>
              </tr>
              <tr>
                <td colSpan={2} className="text-left bb-h bt-h">
                  ที่อยู่{" "}
                  {data.customer_address === null ||
                  data.customer_address === undefined
                    ? ""
                    : data.customer_address}
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="text-left bb-h bt-h">
                  <br />
                </td>
              </tr>
              <tr>
                <td style={{ width: "55px" }} className="text-left br-h bt-h">
                  โทรศัพท์{" "}
                  {data.customer_tel === null || data.customer_tel === undefined
                    ? ""
                    : data.customer_tel}
                </td>
                <td style={{ width: "55px" }} className="text-left bt-h bl-h">
                  โทรสาร{" "}
                  {data.customer_fax === null || data.customer_fax === undefined
                    ? ""
                    : data.customer_fax}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ width: "1%", display: "inline-block" }}></div>
        <div style={{ width: "59.5%", display: "inline-block" }}>
          <table
            className="table table-ssr-general-doc line-low"
            style={{ height: 100 }}
          >
            <tbody>
              <tr>
                <td style={{ width: "25%" }} className="text-left bb-h">
                  ทะเบียนรถ
                </td>
                <td style={{ width: "25%" }} className="bl-h bb-h">
                  {data.car === null || data.car === undefined
                    ? ""
                    : data.car.car_registration_no}
                </td>
                <td style={{ width: "25%" }} className="text-left bl-h bb-h">
                  เลขที่เอกสาร
                </td>
                <td style={{ width: "25%" }} className="bl-h bb-h">
                  {data.doc_no === null || data.doc_no === undefined
                    ? ""
                    : data.doc_no}
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h">เคลม</td>
                <td className="bt-h bl-h bb-h">
                  {data.claim_no === null || data.claim_no === undefined
                    ? ""
                    : data.claim_no}
                </td>
                <td className="text-left bt-h bl-h bb-h">วันที่ออกเอกสาร</td>
                <td className="bt-h bl-h bb-h">
                  {data.doc_date === null || data.doc_date === undefined
                    ? ""
                    : data.doc_date}
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h">ประเภทรถ</td>
                <td className="bt-h bl-h bb-h">
                  {data.car && data.car.accident_type
                    ? data.car.accident_type
                    : ""}
                </td>
                <td className="text-left bt-h bl-h bb-h">เงื่อนไขการชำระ</td>
                <td className="bt-h bl-h bb-h">
                  {data.credit_day === null || data.credit_day === undefined
                    ? ""
                    : data.credit_day}
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h">ยี่ห้อ</td>
                <td className="bt-h bl-h bb-h">
                  {data.car === null || data.car === undefined
                    ? ""
                    : data.car.brand}
                </td>
                <td className={"text-left bt-h bl-h bb-h " + rdClass}>
                  <span>วันส่งรถเข้าซ่อม</span>
                </td>
                <td className={"bt-h bl-h bb-h " + rdClass}>
                  <span>
                    {data.entrance_date === null ||
                    data.entrance_date === undefined
                      ? ""
                      : data.entrance_date}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h">ขนาด(ซีซี)</td>
                <td className="bt-h bl-h bb-h">
                  {data.car && data.car.car_cc ? data.car.car_cc : ""}{" "}
                  {data.car && data.car.year ? "ปี " + data.car.year : ""}
                </td>
                <td className={"text-left bt-h bl-h bb-h " + rdClass}>
                  <span>วันรับรถซ่อมเสร็จ</span>
                </td>
                <td className={"bt-h bl-h bb-h " + rdClass}>
                  <span>
                    {data.delivering_date === null ||
                    data.delivering_date === undefined
                      ? ""
                      : data.delivering_date}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h bb-h">หมายเลขตัวถัง</td>
                <td className="bt-h bl-h bb-h">
                  {data.car === null || data.car === undefined
                    ? ""
                    : data.car.chassis_no}
                </td>
                <td className={"text-left bt-h bl-h bb-h " + rdClass}>
                  <span>เลขไมล์รถเข้าซ่อม</span>
                </td>
                <td className={"bt-h bl-h bb-h " + rdClass}>
                  <span>
                    {data.car === null || data.car === undefined
                      ? ""
                      : data.car.mileage}{" "}
                    km
                  </span>
                </td>
              </tr>
              <tr>
                <td className="text-left bt-h"></td>
                <td className="bt-h bl-h"></td>
                <td className={"text-left bt-h bl-h  " + rdClass}>
                  <span>เลขไมล์รถซ่อมเสร็จ</span>
                </td>
                <td className={"bt-h bl-h " + rdClass}>
                  <span>
                    {data.job_done_mileage === null ||
                    data.job_done_mileage === undefined
                      ? ""
                      : data.job_done_mileage}{" "}
                    km
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {this.renderTable(itemlist, itemIndex)}
        {this.renderSignature()}
      </div>
    );
  }

  renderTable(itemlist, itemIndex) {
    let { data } = this.state;
    let total = this.getSummaryAmount();
    let vat = data.amount - total;

    return (
      <div>
        <table className="table table-ssr-general-doc">
          <tbody>
            <tr>
              <td style={{ width: "50px" }} className="text-center br-h bb-h">
                ลำดับ <br /> ITEM
              </td>
              <td style={{ width: "500px" }} className="text-center br-h bb-h">
                รายการ <br /> DESCRIPTION
              </td>
              <td style={{ width: "100px" }} className="text-center br-h bb-h">
                จำนวน <br /> QUANTITY
              </td>
              <td style={{ width: "120px" }} className="text-center br-h bb-h">
                ราคา/หน่วย <br />
                UNIT PRICE
              </td>
              <td style={{ width: "120px" }} className="text-center bb-h">
                จำนวนเงิน <br /> Amount
              </td>
            </tr>
            {this.renderRowData(itemlist, itemIndex)}
            <tr>
              <td
                className="text-left bt-h br-h line-mid p1"
                colSpan={2}
                style={{ verticalAlign: "middle" }}
              >
                ถ้าเป็นการชำระด้วยเช็ค ใบเสร็จฯ จะสมบูรณ์เมื่อบริษัทฯ
                ขึ้นเงินตามเช็คจากธนาคารได้แล้ว <br />
                In case of the payment paid by cheque, this receipt be valid
                only when <br />
                bank honored the cheque.
              </td>
              <td
                className="bt-h br-h text-left p1"
                colSpan={2}
                style={{ verticalAlign: "middle" }}
              >
                รวมราคาสินค้า / TOTAL
              </td>
              <td
                className="bt-h text-right p1"
                style={{ verticalAlign: "middle" }}
              >
                {this.getNumberFormat(data.amount - data.vat_amount)}
              </td>
            </tr>
            <tr>
              <td
                className="text-left bt-h br-h bbl-radius-8 p1"
                colSpan={2}
                rowSpan={2}
                style={{ verticalAlign: "middle" }}
              >
                {data.grand_total_thai === "" ||
                data.grand_total_thai === null ||
                data.grand_total_thai === undefined
                  ? "( ศูนย์บาทถ้วน )"
                  : "( " + data.grand_total_thai + " )"}
              </td>
              <td
                className="bt-h br-h text-left p1"
                colSpan={2}
                style={{ verticalAlign: "middle" }}
              >
                ภาษีมูลค่าเพิ่ม / VAT 7%
              </td>
              <td
                className="bt-h text-right p1"
                style={{ verticalAlign: "middle" }}
              >
                {this.getNumberFormat(data.vat_amount)}
              </td>
            </tr>
            <tr>
              <td
                className="text-left bt-h br-h bbl-radius-0 p1"
                colSpan={2}
                style={{ verticalAlign: "middle" }}
              >
                จำนวนเงินรวมทั้งสิ้น / GRAND TOTAL
              </td>
              <td
                className="bt-h text-right p1"
                style={{ verticalAlign: "middle" }}
              >
                {this.getNumberFormat(data.amount)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderRowData(itemlist, itemIndex) {
    return itemlist.data.map((item, index) => {
      return (
        <tr key={index}>
          <td
            className={
              (index === itemlist.data.length - 1 ? "" : "bb-h ") +
              "text-center br-h " +
              (index > 0 ? "bt-h p1" : "")
            }
          >
            {item.seq === "" ? <br /> : index + 1}
          </td>
          <td
            className={
              (index === itemlist.data.length - 1 ? "" : "bb-h ") +
              (index > 0 ? "bt-h br-h p1" : "br-h p1")
            }
          >
            {item.seq === "" ? "" : item.detail}
          </td>
          <td
            className={
              (index === itemlist.data.length - 1 ? "" : "bb-h ") +
              "text-center br-h " +
              (index > 0 ? "bt-h p1" : "")
            }
          >
            {item.seq === "" || item.quantity === "0" || item.quantity === ""
              ? ""
              : item.quantity}
          </td>
          <td
            className={
              (index === itemlist.data.length - 1 ? "" : "bb-h ") +
              "text-right br-h " +
              (index > 0 ? "bt-h p1" : "")
            }
          >
            {item.seq === "" || item.quantity === "0" || item.quantity === ""
              ? ""
              : this.getNumberFormat(item.price_per_unit)}
          </td>
          <td
            className={
              (index === itemlist.data.length - 1 ? "" : "bb-h ") +
              "text-right " +
              (index > 0 ? "bt-h p1" : "")
            }
          >
            {item.seq === "" || item.quantity === "0" || item.quantity === ""
              ? ""
              : this.getNumberFormat(item.amount)}
          </td>
        </tr>
      );
    });
  }

  // onLoadSignature(field) {
  //   let {signature} = this.state
  //   this.setState({sigKey:field})
  //   let action = 'del'
  //   if (signature[field]===null)
  //     action = 'add'
  //   this.refs.signatureModal.onSentSignatureConfirm(action)
  // }

  // onSentSignature(item) {
  //   let {signature,sigKey} = this.state
  //   signature[sigKey] = item.signature_data_url
  //   this.setState({signature:signature,sigKey:null})
  // }

  renderComponentPage(itemlist, itemIndex) {
    let { data, defaultTypePrint, title_doc_active } = this.state;
    let { header_style } = this.props;
    let titles = title_doc_active.split(/\n/g);
    return (
      <div key={itemIndex}>
        <div className="font-print print-dear">
          <div>
            {header_style === "2" ? (
              <div>
                <div style={{ display: "flex", width: "100%" }}>
                  <div style={{ width: "42%" }}>
                    <section className="font-16">
                      <strong>
                        <h4 style={{ margin: "0", fontWeight: "bold" }}>
                          {data.company_name !== undefined
                            ? data.company_name
                            : ""}{" "}
                          {data.company_branch !== undefined
                            ? data.company_branch
                            : ""}
                        </h4>
                        <h4 style={{ margin: "0", fontWeight: "bold" }}>
                          {data.company_en !== undefined
                            ? data.company_en.company_name
                            : ""}
                        </h4>
                        <p style={{ lineHeight: "0.7" }}>
                          {data.company_addr !== undefined
                            ? data.company_addr
                            : ""}
                        </p>
                        <p style={{ lineHeight: "0.7" }}>
                          โทร.{" "}
                          {data.company_tel !== undefined
                            ? data.company_tel
                            : ""}{" "}
                          FAX.{" "}
                          {data.company_fax !== undefined
                            ? data.company_fax
                            : ""}
                        </p>
                      </strong>
                    </section>
                  </div>
                  <div className="text-center" style={{ width: "23%" }}>
                    {this.renderLogoUrl(data.logo_url)}
                  </div>
                  <div className="text-center" style={{ width: "35%" }}>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        border: "1px solid #111",
                      }}
                    >
                      <div
                        className="doc-type"
                        style={{
                          padding: "3px",
                          backgroundColor: "#333",
                          width: "30%",
                          borderRight: "1px solid #111",
                          color: "#fff",
                        }}
                      >
                        <h3 style={{ margin: "0" }}>
                          {itemlist.type === "ori"
                            ? "ต้นฉบับ"
                            : itemlist.type === "copy"
                            ? "สำเนา"
                            : ""}
                        </h3>
                        <h3 style={{ margin: "0" }}>
                          {itemlist.type === "ori"
                            ? "ORIGINAL"
                            : itemlist.type === "copy"
                            ? "COPY"
                            : ""}
                        </h3>
                      </div>
                      <div style={{ width: "70%", padding: "10px" }}>
                        {titles.map((item, index) => {
                          return (
                            <h4
                              key={index}
                              style={{ margin: "0", fontWeight: "bold" }}
                            >
                              {item}
                            </h4>
                          );
                        })}
                      </div>
                    </div>
                    <p style={{ lineHeight: "0.7" }}>(เอกสารออกเป็นชุด)</p>
                  </div>
                </div>
                <br />
              </div>
            ) : (
              <div>
                <header className="title-header">
                  <h2 className="font-print-40">{title_doc_active}</h2>
                </header>
                <article className={"article-company " + data.logo_class}>
                  <div
                    style={{
                      width: data.logo_width + "px",
                      minWidth: data.logo_width + "px",
                      textAlign: "center",
                      lineHeight: "70px",
                    }}
                  >
                    {this.renderLogoUrl(data.logo_url)}
                  </div>
                  <section
                    style={{
                      width: "85%",
                      paddingTop:
                        data.logo_class === "bg-logo-absolute" ? "0" : "15px",
                    }}
                  >
                    <strong>
                      <p
                        className="font-header company-name"
                        style={{ lineHeight: "0.7" }}
                      >
                        {data.company_name !== undefined
                          ? data.company_name
                          : ""}
                      </p>
                      <p className="font-header" style={{ lineHeight: "0.7" }}>
                        {data.company_addr !== undefined
                          ? data.company_addr
                          : ""}
                      </p>
                      <p className="font-header" style={{ lineHeight: "0.7" }}>
                        เลขประจำตัวผู้เสียภาษี{" "}
                        {data.company_tax !== undefined ? data.company_tax : ""}
                      </p>
                      <p className="font-header" style={{ lineHeight: "0.7" }}>
                        โทร{" "}
                        {data.company_tel !== undefined ? data.company_tel : ""}
                      </p>
                    </strong>
                  </section>
                  <section className="text-right sec-copy-doc">
                    <span
                      id="sec-copy-doc"
                      style={{
                        display: defaultTypePrint === "0" ? "none" : "",
                      }}
                    >
                      {itemlist.type === "ori"
                        ? "ต้นฉบับ"
                        : itemlist.type === "copy"
                        ? "สำเนา"
                        : ""}
                    </span>
                  </section>
                </article>
              </div>
            )}
            {this.renderBody(itemlist.data, itemIndex)}
          </div>
        </div>
        {/* <SignatureModal
            ref='signatureModal'
            mode='print'
            onSentSignature={this.onSentSignature.bind(this)}
          /> */}
      </div>
    );
  }

  onTypePrintChange(e) {
    this.setState({ defaultTypePrint: e });
  }

  getPagination(data) {
    let checkRow = 0;
    let newData = [];
    let allData = [];
    // let summary = {sum:false,sum1:false,sum2:false,sum3:false,sum4:false,sum5:false}
    let summary = {
      sum: true,
      sum1: true,
      sum2: true,
      sum3: true,
      sum4: true,
      sum5: true,
    };
    data.forEach((item, index) => {
      if (checkRow < DEFAUT_ROW) {
        newData.push(item);
      }
      if (checkRow == DEFAUT_ROW - 1 || index == data.length - 1) {
        allData.push({
          data: newData,
          summary: summary,
        });
        newData = [];
        checkRow = -1;
      }
      checkRow++;
    });

    // if (allData.length>0) {
    //     if (DEFAUT_ROW-allData[allData.length-1].data.length>=6) {
    //         allData[allData.length-1].data = allData[allData.length-1].data.concat(this.newEmptyRow(DEFAUT_ROW-(allData[allData.length-1].data.length+6)))
    //         allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
    //     } else if (DEFAUT_ROW-allData[allData.length-1].data.length>4&&DEFAUT_ROW-allData[allData.length-1].data.length<=5) {
    //         allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:false}
    //         allData.push({
    //             data:this.newEmptyRow(DEFAUT_ROW-1),
    //             summary:{sum:false,sum1:false,sum2:false,sum3:false,sum4:false,sum5:true}
    //         })
    //     } else if (DEFAUT_ROW-allData[allData.length-1].data.length>3&&DEFAUT_ROW-allData[allData.length-1].data.length<=4) {
    //         allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:true,sum4:false,sum5:false}
    //         allData.push({
    //             data:this.newEmptyRow(DEFAUT_ROW-2),
    //             summary:{sum:false,sum1:false,sum2:false,sum3:false,sum4:true,sum5:true}
    //         })
    //     } else if (DEFAUT_ROW-allData[allData.length-1].data.length>2&&DEFAUT_ROW-allData[allData.length-1].data.length<=3) {
    //         allData[allData.length-1].summary = {sum:true,sum1:true,sum2:true,sum3:false,sum4:false,sum5:false}
    //         allData.push({
    //             data:this.newEmptyRow(DEFAUT_ROW-3),
    //             summary:{sum:false,sum1:false,sum2:false,sum3:true,sum4:true,sum5:true}
    //         })
    //     } else if (DEFAUT_ROW-allData[allData.length-1].data.length>1&&DEFAUT_ROW-allData[allData.length-1].data.length<=2) {
    //         allData[allData.length-1].summary = {sum:true,sum1:true,sum2:false,sum3:false,sum4:false,sum5:false}
    //         allData.push({
    //             data:this.newEmptyRow(DEFAUT_ROW-4),
    //             summary:{sum:false,sum1:false,sum2:true,sum3:true,sum4:true,sum5:true}
    //         })
    //     } else if (DEFAUT_ROW-allData[allData.length-1].data.length>0&&DEFAUT_ROW-allData[allData.length-1].data.length<=1) {
    //         allData[allData.length-1].summary = {sum:true,sum1:false,sum2:false,sum3:false,sum4:false,sum5:false}
    //         allData.push({
    //             data:this.newEmptyRow(DEFAUT_ROW-5),
    //             summary:{sum:false,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
    //         })
    //     } else if (DEFAUT_ROW-allData[allData.length-1].data.length<=0) {
    //         allData.push({
    //             data:this.newEmptyRow(DEFAUT_ROW-6),
    //             summary:{sum:true,sum1:true,sum2:true,sum3:true,sum4:true,sum5:true}
    //         })
    //     }
    // }
    return allData;
  }

  renderNoData() {
    return (
      <div className={"font-print"}>
        <div className="no-of-page">
          <span>
            <br />
          </span>
        </div>
        <header className="align-center">
          <h2 className={this.state.title_destop}>{this.state.report_title}</h2>
        </header>
      </div>
    );
  }

  setPageRender(dataList, defaultTypePrint) {
    let pages = [];
    dataList.forEach((item, index) => {
      if (
        defaultTypePrint == "1" ||
        defaultTypePrint == "3" ||
        defaultTypePrint == "0"
      ) {
        pages.push({
          page: index + 1,
          type: "ori",
          data: item,
        });
      } else if (defaultTypePrint == "2") {
        pages.push({
          page: index + 1,
          type: "copy",
          data: item,
        });
      }
    });
    if (defaultTypePrint == "3" || defaultTypePrint == "0") {
      pages.forEach((item, index) => {
        pages.push({
          page: pages[pages.length - 1].page + 1,
          type: "copy",
          data: item.data,
        });
      });
    }
    return pages;
  }

  onTitleSelect(title) {
    this.setState({ title_doc_active: title }, () => {
      let postData = { title_doc: title };
      PdfStore.saveTaxinvoiceTitleDoc(
        this.state.tivNo,
        postData,
        (result) => {
          if (result.status === "OK") {
            this.refs.notificationSystem.addNotification({
              title: "แจ้งเตือน",
              message: "ทำการบันทึกการเปลี่ยนแปลงเรียบร้อย",
              level: "info",
              position: "tc",
            });
          }
        },
        () => {
          this.refs.notificationSystem.addNotification({
            title: "แจ้งเตือน",
            message: "ไม่สามารถทำการบันทึกการเปลี่ยนแปลงได้",
            level: "error",
            position: "tc",
          });
        }
      );
    });
  }

  onRederDDLeftBarTitle() {
    let { title_doc_options, title_doc_active } = this.state;
    return (
      <DropdownButton
        style={{
          color: "#333",
          fontWeight: "bold",
          fontSize: "18px",
          padding: "0",
          marginTop: "-3px",
        }}
        id="dd-print-title"
        bsStyle="link"
        title={title_doc_active}
        onSelect={this.onTitleSelect.bind(this)}
      >
        <div style={{ paddingLeft: "20px", color: "#333" }}>เลือกข้อความ</div>
        {title_doc_options.map((item, index) => (
          <MenuItem key={index} eventKey={item}>
            <Radio
              radioClass="iradio_flat-blue"
              increaseArea="20%"
              disabled={title_doc_active === item ? false : true}
              checked={title_doc_active === item ? true : false}
            ></Radio>{" "}
            {item}
          </MenuItem>
        ))}
      </DropdownButton>
    );
  }

  render() {
    let { loading, dataList, defaultTypePrint } = this.state;
    let pages = this.setPageRender(dataList, defaultTypePrint);

    if (dataList.length == 0) {
      return (
        <PrintPreview
          loading={loading}
          leftBarTitle={this.state.title_doc}
          onRederDDLeftBarTitle={this.onRederDDLeftBarTitle.bind(this)}
          sliptable="sliptable-page-desktop orc"
        >
          {this.renderNoData()}
        </PrintPreview>
      );
    } else {
      return (
        <div>
          <PrintPreview
            loading={loading}
            leftBarTitle={this.state.title_doc}
            onRederDDLeftBarTitle={this.onRederDDLeftBarTitle.bind(this)}
            onTypePrintChange={this.onTypePrintChange.bind(this)}
            defaultTypePrint={this.state.defaultTypePrint}
            showPageNumber={false}
            sliptable="sliptable-page-desktop orc"
          >
            {pages.map((item, index) => {
              return this.renderComponentPage(item, index);
            })}
          </PrintPreview>
          <NotificationSystem ref="notificationSystem" />
        </div>
      );
    }
  }
}

PrintDearTaxInvoiceDoc.defaultProps = {
  mode: "1",
  title: "ใบกำกับภาษี/ใบเสร็จรับเงิน (TAX INVOICE/RECEIPT)",
  doc: "invoice_doc",
  param: "tiv",
  header_style: "2",
};
export default PrintDearTaxInvoiceDoc;



// WEBPACK FOOTER //
// ./src/view/print/dear/PrintDearTaxInvoiceDoc.js